'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var getDebugLogJsErrorEndpoint = exports.getDebugLogJsErrorEndpoint = function getDebugLogJsErrorEndpoint() {
  return 'Debug:log_js_error';
};